<div class="container-tab-lists nxtdc">
  <div class="inner-tcontainer-tab">
    <div style="position:relative">
      <div class="deployment-info">
        <h2 class="flex-aligned-div" (click)="openDeploymentInformationPopup()">
          Deployment information
          <mat-icon data-html="true" class="info-icon">info</mat-icon>
        </h2>
      </div>
      <div class="tab-body">
        <div class="tab-content">
          <mat-tab-group #tabGroup
            mat-stretch-tabs="false"
            (selectedTabChange)="defaults.updateComponentTab($event.tab.textLabel);">
            @if (defaults.isEMTFactorySupportEngineer) {
              <mat-tab label="Version Releases">
                <softwarereleasetofield #softwarereleasetofieldComponent
                  (saveSuccess)="onSoftwareReleaseListSaved()"
                [familyCodes]="familyCodes"></softwarereleasetofield>
              </mat-tab>
            }
            <mat-tab label="Mandatory Version Updates">
              <mandatoryversionupdate #mandatoryversionupdates
              [familyCodes]="familyCodes"></mandatoryversionupdate>
            </mat-tab>
            @if (defaults.isMFGEquipmentManagerUser) {
              <mat-tab label="Unit Activation Settings">
                <unitactivation #emtconfiguration></unitactivation>
              </mat-tab>
            }
            <mat-tab label="OTA Settings">
              @if (defaults.isEMTFieldSupportEngineer) {
                <otasettings #otasettings></otasettings>
              }
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </div>
</div>
